import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import Event from '../../actions/event';
import Api from '../../../api';
import {DeleteWorkingTimePayload} from '../../actions/workingTimeCommand';

const onDeleteWorkingTime = function*(data: DeleteWorkingTimePayload) {
    try {
        yield call(Api.Command.WorkingTime.deleteWorkingTime, {
            workingTimeId: data.workingTimeId,
        });

        yield put(Event.WorkingTime.workingTimeDeleted({
            workingTimeId: data.workingTimeId,
            projectId: data.projectId,
            start: data.start,
            end: data.end,
        }));

        yield put(Event.Customer.workingTimeDeleted({
            projectId: data.projectId,
            start: data.start,
            end: data.end,
        }));

        yield put(Command.Notification.enqueueNotification({
            severity: 'success',
            message: 'Die Arbeitszeit wurde gelöscht.',
        }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Die Arbeitszeit konnte nicht gelöscht werden.',
        }));
    }
};

export function* deleteWorkingTimeFlow() {
    while (true) {
        const action: Action<DeleteWorkingTimePayload> =
            yield take(Command.WorkingTime.deleteWorkingTime.toString());
        yield fork(onDeleteWorkingTime, action.payload);
    }
}
